import {PersonDocumentType, PersonDocumentTypeRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import React from "react";

export const PersonDocumentTypeListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<PersonDocumentType> = {
		title: "Tipos de Documento de Persona",
		onClick: "/app/admin/employee/persondoctype",
		headers: [
			{title: "Nombre"},
			{title: "Requiere Mes/Año"},
			{title: "Requiere Expiración"},
		],
		decorator: (bean: PersonDocumentType) => (
			< >
				<TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
					{bean.name}
				</TableCell>
				<TableCell>
					{bean.requiredYearMonth ? "Sí" : ""}
				</TableCell>
				<TableCell>
					{bean.requiredExpiration ? "Sí" : ""}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(PersonDocumentTypeRestControllerApiFactory);
			return ctrl.pagePersonDocumentType(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};